/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$('.Popover__LineItem__Input').change(function(){
    var val = $(this).val();
$('#ring-size-i1').val(val);
    });

/*** Validation for ring size dropdown in product page */
function validateRingSize(form) {
    var ringSizeValue = Array.from(
        form.querySelectorAll('.ProductForm__SelectedValue')
    ).find(function (element) {
        return element.getAttribute('data-attr') === 'Ring Size: ';
    });

    if (!ringSizeValue) return true;

    var ringSizeOption = ringSizeValue.closest('.ProductForm__Option');
    var ringSizeButton = ringSizeOption
        ? ringSizeOption.querySelector('.ProductForm__Item')
        : null;

    var selectedValue = ringSizeValue.textContent.trim();
    var dataAttr = ringSizeValue.getAttribute('data-attr');

    if (dataAttr) {
        selectedValue = selectedValue
            .replace(dataAttr.trim(), '')
            .trim();
    }

    // Remove existing error
    var existingError = ringSizeOption
        ? ringSizeOption.querySelector('.RingSizeError')
        : null;

    if (selectedValue === 'Select a Ring Size') {

        // Add 1px red border to Select a Ring Size button
        if (ringSizeButton) {
            ringSizeButton.style.border = '1px solid red';
        }

        // Show error message
        if (!existingError && ringSizeOption) {
            var errorMessage = document.createElement('small');

            errorMessage.className = 'RingSizeError';
            errorMessage.textContent = 'Please select a ring size.';
            errorMessage.style.color = 'red';
            errorMessage.style.display = 'block';
            errorMessage.style.fontSize = '12px';
            errorMessage.style.marginTop = '5px';

            ringSizeOption.appendChild(errorMessage);
        }

        return false;
    }

    // Valid selection - remove error styling/message
    if (ringSizeButton) {
        ringSizeButton.style.border = '';
    }

    if (existingError) {
        existingError.remove();
    }

    return true;
}


// Click on Add to Cart
document.addEventListener('click', function (event) {
    var button = event.target.closest('.ProductForm__AddToCart');

    if (!button) return;

    var form = button.closest('form');

    if (!form) return;

    if (!validateRingSize(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
}, true);


// Form submit
document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!form.matches('form')) return;

    if (!validateRingSize(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
}, true);

document.querySelectorAll(
    '.ProductForm__SelectedValue[data-attr="Ring Size: "]'
).forEach(function (ringSizeValue) {

    var observer = new MutationObserver(function () {
        var value = ringSizeValue.textContent.trim();
        var dataAttr = ringSizeValue.getAttribute('data-attr');

        if (dataAttr) {
            value = value.replace(dataAttr.trim(), '').trim();
        }

        if (value !== 'Select a Ring Size') {
            var ringSizeOption = ringSizeValue.closest('.ProductForm__Option');

            if (!ringSizeOption) return;

            var ringSizeButton = ringSizeOption.querySelector('.ProductForm__Item');

            if (ringSizeButton) {
                ringSizeButton.style.border = '';
            }

            var errorMessage = ringSizeOption.querySelector('.RingSizeError');

            if (errorMessage) {
                errorMessage.remove();
            }
        }
    });

    observer.observe(ringSizeValue, {
        childList: true,
        characterData: true,
        subtree: true
    });
});

/*** Code for Description tab in product page */

document.addEventListener('DOMContentLoaded', function () {
  var tabs = document.querySelector('.Product__Tabs');
  var description = document.querySelector('.ProductMeta__Description');

  if (!tabs || !description) return;

  // Get the existing dynamic description content
  var descriptionRte = description.querySelector('.Rte');

  if (!descriptionRte) return;

  // Create the Description tab
  var descriptionTab = document.createElement('div');
  descriptionTab.className = 'Collapsible Collapsible--large';

  descriptionTab.innerHTML = `
    <button
      class="Collapsible__Button Heading u-h6"
      data-action="toggle-collapsible"
      aria-expanded="false"
      type="button"
    >
      Description
      <span class="Collapsible__Plus"></span>
    </button>

    <div class="Collapsible__Inner">
      <div class="Collapsible__Content"></div>
    </div>
  `;

  // Move the EXISTING description content.
  // Nothing is hard-coded from the product description.
  descriptionTab
    .querySelector('.Collapsible__Content')
    .appendChild(descriptionRte);

  // Put Description at the top of the existing tabs
  tabs.insertBefore(descriptionTab, tabs.firstElementChild);

  // Remove the original sidebar description
  description.remove();
});
(function () {
  var ringSizeParam = 'la_ring_size';

  function parseJson(value) {
    if (!value) return [];

    try {
      return JSON.parse(value);
    } catch (error) {
      return [];
    }
  }

  function normalize(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function isMetalOption(name) {
    return normalize(name).indexOf('metal') !== -1;
  }

  function getSelectedVariantOptions(overridePosition, overrideValue) {
    var selected = {};

    document.querySelectorAll(
      '.OptionSelector button[data-action="select-value"][data-option-position].is-selected'
    ).forEach(function (button) {
      selected[String(button.getAttribute('data-option-position'))] =
        button.getAttribute('data-value') || '';
    });

    if (overridePosition && overrideValue) {
      selected[String(overridePosition)] = overrideValue;
    }

    return selected;
  }

  function getRingSize() {
    var hiddenInput = document.getElementById('ring-size-i1');

    if (hiddenInput && hiddenInput.value && hiddenInput.value !== 'i') {
      return hiddenInput.value;
    }

    var checkedInput = document.querySelector(
      '.Popover__LineItem__Input[name="properties[Ring Size]"]:checked'
    );

    return checkedInput ? checkedInput.value : '';
  }

  function findTargetVariant(link, selectedOptions) {
    var targetOptionNames = parseJson(
      link.getAttribute('data-target-option-names')
    );
    var targetVariants = parseJson(
      link.getAttribute('data-target-variants')
    );

    for (var i = 0; i < targetVariants.length; i++) {
      var targetVariant = targetVariants[i];
      var matches = true;

      for (var j = 0; j < targetOptionNames.length; j++) {
        if (isMetalOption(targetOptionNames[j])) {
          continue;
        }

        var selectedValue = selectedOptions[String(j + 1)];

        if (!selectedValue) {
          matches = false;
          break;
        }

        if (normalize(targetVariant.options[j]) !== normalize(selectedValue)) {
          matches = false;
          break;
        }
      }

      if (matches) {
        return targetVariant;
      }
    }

    return null;
  }

  function updateMetalLinks(overridePosition, overrideValue, overrideRingSize) {
    var selectedOptions = getSelectedVariantOptions(
      overridePosition,
      overrideValue
    );
    var ringSize = overrideRingSize || getRingSize();
    var currentUrl = new URL(window.location.href);

    document.querySelectorAll('[data-metal-product-link]').forEach(function (link) {
      var baseUrl = link.getAttribute('data-base-url') || link.getAttribute('href');
      var url = new URL(baseUrl, window.location.origin);
      var targetVariant = findTargetVariant(link, selectedOptions);

      currentUrl.searchParams.forEach(function (value, key) {
        if (
          key !== 'variant' &&
          key !== ringSizeParam &&
          !url.searchParams.has(key)
        ) {
          url.searchParams.set(key, value);
        }
      });

      if (targetVariant && targetVariant.id) {
        url.searchParams.set('variant', targetVariant.id);
      }

      if (ringSize) {
        url.searchParams.set(ringSizeParam, ringSize);
      } else {
        url.searchParams.delete(ringSizeParam);
      }

      link.setAttribute('href', url.toString());
    });
  }

  function restoreRingSizeFromUrl(attempt) {
    var params = new URL(window.location.href).searchParams;
    var ringSize = params.get(ringSizeParam);

    if (!ringSize) {
      updateMetalLinks();
      return;
    }

    var inputs = document.querySelectorAll(
      '.Popover__LineItem__Input[name="properties[Ring Size]"]'
    );
    var matchingInput = null;

    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === ringSize) {
        matchingInput = inputs[i];
        break;
      }
    }

    if (!matchingInput) {
      if (attempt < 20) {
        window.setTimeout(function () {
          restoreRingSizeFromUrl(attempt + 1);
        }, 100);
      }

      return;
    }

    matchingInput.checked = true;
    matchingInput.dispatchEvent(new Event('change', { bubbles: true }));

    var hiddenInput = document.getElementById('ring-size-i1');

    if (hiddenInput) {
      hiddenInput.value = ringSize;
    }

    var selectedValue = document.querySelector(
      '.ProductForm__SelectedValue[data-attr="Ring Size: "]'
    );

    if (selectedValue) {
      selectedValue.textContent = ringSize;
    }

    var popoverValue = matchingInput.closest('.Popover__Value');

    if (popoverValue && popoverValue.parentNode) {
      popoverValue.parentNode
        .querySelectorAll('.Popover__Value')
        .forEach(function (item) {
          item.classList.remove('is-selected');
        });

      popoverValue.classList.add('is-selected');
    }

    var cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete(ringSizeParam);
    window.history.replaceState({}, '', cleanUrl.toString());

    updateMetalLinks(null, null, ringSize);
  }

  document.addEventListener(
    'click',
    function (event) {
      var optionButton = event.target.closest(
        '.OptionSelector button[data-action="select-value"][data-option-position]'
      );

      if (!optionButton) {
        return;
      }

      var position = optionButton.getAttribute('data-option-position');
      var value = optionButton.getAttribute('data-value');

      window.setTimeout(function () {
        updateMetalLinks(position, value);
      }, 0);
    },
    true
  );

  document.addEventListener('change', function (event) {
    var ringSizeInput = event.target.closest(
      '.Popover__LineItem__Input[name="properties[Ring Size]"]'
    );

    if (!ringSizeInput) {
      return;
    }

    updateMetalLinks(null, null, ringSizeInput.value);
  });

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;

    if (!variant || !Array.isArray(variant.options)) {
      updateMetalLinks();
      return;
    }

    var links = document.querySelectorAll('[data-metal-product-link]');

    links.forEach(function (link) {
      var targetOptionNames = parseJson(
        link.getAttribute('data-target-option-names')
      );
      var selectedOptions = {};

      targetOptionNames.forEach(function (name, index) {
        if (!isMetalOption(name) && variant.options[index] != null) {
          selectedOptions[String(index + 1)] = variant.options[index];
        }
      });

      var currentUrl = new URL(window.location.href);
      var baseUrl = link.getAttribute('data-base-url') || link.getAttribute('href');
      var url = new URL(baseUrl, window.location.origin);
      var targetVariant = findTargetVariant(link, selectedOptions);
      var ringSize = getRingSize();

      currentUrl.searchParams.forEach(function (value, key) {
        if (
          key !== 'variant' &&
          key !== ringSizeParam &&
          !url.searchParams.has(key)
        ) {
          url.searchParams.set(key, value);
        }
      });

      if (targetVariant && targetVariant.id) {
        url.searchParams.set('variant', targetVariant.id);
      }

      if (ringSize) {
        url.searchParams.set(ringSizeParam, ringSize);
      }

      link.setAttribute('href', url.toString());
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      restoreRingSizeFromUrl(0);
    });
  } else {
    restoreRingSizeFromUrl(0);
  }

  document.addEventListener('product_page:loaded', function () {
    window.setTimeout(function () {
      restoreRingSizeFromUrl(0);
    }, 0);
  });
})();
